module.exports = __webpack_public_path__ + "img/blogpost10.caaac4ad.jpg";